import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { useT } from '../lib/i18n'
import HeroQuote from '../components/hero/HeroQuote'
import HeroCTA from '../components/hero/HeroCTA'
import HeroPatternOverlay from '../components/ornaments/HeroPatternOverlay'
import ArabesqueBorder from '../components/ornaments/ArabesqueBorder'
import DividerOrnament from '../components/ornaments/DividerOrnament'
import useReducedMotion from '../hooks/useReducedMotion'

const ease = [0.22, 1, 0.36, 1]

export default function Home() {
  const t = useT()
  const reduced = useReducedMotion()

  return (
    <>
      <Helmet>
        <title>{t('brand.full')}</title>
        <meta name="description" content={t('brand.full')} />
      </Helmet>

      {/* ─── Hero (slide 1: ceremonial quote) ─────────────────────── */}
      <section className="relative min-h-[100vh] flex items-center justify-center overflow-hidden bg-[var(--color-indigo-800)]">
        <HeroPatternOverlay />
        <div className="container-x relative z-10 py-24 md:py-32">
          <HeroQuote />
        </div>
      </section>

      {/* ─── Landing (slide 2: title + CTA) ───────────────────────── */}
      <section className="relative bg-[var(--color-indigo-900)] py-20 md:py-28 overflow-hidden">
        <div className="container-x relative z-10 text-center">
          <ArabesqueBorder className="mb-12 max-w-2xl mx-auto" />

          <motion.h1
            className="font-display font-bold text-5xl md:text-7xl tracking-tight text-white mb-6"
            initial={reduced ? false : { opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.72, ease }}
          >
            {t('hero.title')}
          </motion.h1>

          <motion.p
            className="font-display italic text-5xl md:text-7xl text-white mb-3"
            initial={reduced ? false : { opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease }}
          >
            {t('hero.subtitle')}
          </motion.p>

          <motion.p
            className="font-display font-bold text-3xl md:text-5xl tracking-[0.2em] text-white mb-12"
            initial={reduced ? false : { opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.4, ease }}
          >
            {t('hero.subtitleAccent')}
          </motion.p>

          <HeroCTA />

          <ArabesqueBorder className="mt-16 max-w-2xl mx-auto" />
        </div>
      </section>

      {/* ─── Divider section (Phase 2'da batafsil tartib qoʻshiladi) ── */}
      <section className="bg-[var(--color-indigo-800)] py-20">
        <div className="container-x">
          <DividerOrnament className="mb-12" />
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-display text-3xl md:text-4xl mb-6 text-white">
              {t('tartib.title')}
            </h2>
            <p className="text-[var(--color-ink-muted)] leading-relaxed">
              {t('tartib.intro')}
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
